import type { NotificationDto } from "@ied/shared-types";
import {
	createColumnHelper,
	getCoreRowModel,
	type TableOptions,
} from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { useGetNotifications } from "@/hooks/queries/use-get-notifications";
import { Button } from "../ui/button";
import { TanstackTable } from "../ui/table";

export function NotificationsTable() {
	const { data } = useGetNotifications();

	if (!data) {
		return <p>No notifications</p>;
	}
	const cHelper = createColumnHelper<NotificationDto>();
	const columns = [
		cHelper.accessor("id", {
			header: () => "Id",
		}),
		cHelper.accessor("heading", {
			header: () => "Title",
		}),
		cHelper.accessor("sub_heading", {
			header: () => "Sub Title",
		}),
		cHelper.accessor("sent_status", {
			header: () => "Status",
		}),
		cHelper.accessor("created", {
			header: () => "Created",
			cell: (row) => (
				<div>
					<p>{new Date(row.getValue()).toLocaleDateString()}</p>
					<p>{new Date(row.getValue()).toLocaleTimeString()}</p>
				</div>
			),
		}),
		cHelper.accessor("updated", {
			header: () => "Updated",
			cell: (row) => (
				<div>
					<p>{new Date(row.getValue()).toLocaleDateString()}</p>
					<p>{new Date(row.getValue()).toLocaleTimeString()}</p>
				</div>
			),
		}),
		cHelper.display({
			id: "actions",
			cell: (props) => (
				<Button variant="link" className="cursor-pointer">
					<Link to={props.row.original.id} viewTransition>
						View
					</Link>
				</Button>
			),
		}),
	];
	const tableOptions: TableOptions<NotificationDto> = {
		columns,
		data,
		getCoreRowModel: getCoreRowModel(),
	};
	return (
		<>
			<TanstackTable
				options={tableOptions}
				// paginationOptions={{
				//   isPaginated: true,
				//   pageIndex: data.page,
				//   pageSize: data.perPage,
				//   totalCount: data.totalItems,
				// }}
			/>
		</>
	);
}
